<template>
    <SlickProducts :block="block" :numeration="true" :showTitle="(position !== 0)" :showPromoLabel="(position !== 0)" ></SlickProducts>
</template>
<script>
import HomeBlock from '@/models/home-block';
import SlickProducts from './SlickProducts';
export default {
    components:{
        SlickProducts,
    },
    props:{
        block:{
            type: HomeBlock
        },
        position:{
            type: Number,
            default: 0
        }
    }
}
</script>